module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('x-table', [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("购买人")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.usePeopleName))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("所属部门")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.departName))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("行政级别")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.position))]), _vm._v(" "), _c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("申请时间")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.info.applyDate))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "detail-page-title",
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("申请信息")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("单据名称"), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("用途")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remark),
      callback: function($$v) {
        _vm.remark = $$v
      },
      expression: "remark"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("采购事由")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.buyReason),
      callback: function($$v) {
        _vm.buyReason = $$v
      },
      expression: "buyReason"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("备注")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('x-input', {
    attrs: {
      "title": "",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.remark2),
      callback: function($$v) {
        _vm.remark2 = $$v
      },
      expression: "remark2"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "detail-page-name"
  }, [_vm._v("附件上传")]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('input', {
    staticClass: "inputfile",
    attrs: {
      "type": "file",
      "name": "file",
      "id": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.chooseFile
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "btn-file",
    attrs: {
      "for": "file"
    }
  }, [_vm._v("选择")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "box"
    }
  }), _vm._l((_vm.fileShowList), function(item, key) {
    return _c('div', {
      key: key,
      staticClass: "img-box"
    }, [_c('img', {
      staticClass: "icon-close",
      attrs: {
        "src": require("../../../assets/icon/close-blue.png")
      },
      on: {
        "click": function($event) {
          _vm.deleteFile(key)
        }
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "img-part",
      attrs: {
        "src": item,
        "alt": ""
      }
    })])
  }), _vm._v(" "), _c('p')], 2)])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ede2758","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/launch/attendance/buyOfficeApply.vue
// module id = nEEk
// module chunks = 0